<template>
  <b-card header="Company Information" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
    <div v-if="!e_company" class="row">
      <!-- Company Sage Ref -->
      <div class="col-12 form-group" v-if="ifNotCompanyContactUser">
        <div id="payroll_recruitment_client" class="w-100" v-if="crmType === 'payroll' && company.payroll_recruitment_client">
          V3 CLIENT
        </div>
      </div>
      <!-- Company Sage Ref -->
      <div class="col-xl-6 form-group" v-if="ifNotCompanyContactUser">
        <label class="form-label" for="sage_ref">Finance Reference</label>
        <p id="sage_ref" v-html="return_internal_finance_ref"></p>
      </div>
      <!-- Genius Trading Company -->
      <div class="col-xl-6 form-group" v-if="isPayrollCrm">
        <label class="form-label" for="genius_trading_company">Payroll Trading Company</label>
        <p id="genius_trading_company" v-html="return_payroll_trading_company"></p>
      </div>
      <div class="col-xl-6 form-group" v-else></div>
      <!-- Company UTR Number -->
      <div class="col-xl-6 form-group">
        <label class="form-label" for="company_utr_number">Company UTR Number</label>
        <p id="company_utr_number" v-html="return_utr_number"></p>
      </div>
      <!-- UTR Status -->
      <div class="col-xl-6 form-group">
        <label class="form-label" for="company_utr_status">UTR Status</label>
        <p id="company_utr_status" v-html="return_utr_status"></p>
      </div>
      <!-- VAT Registered -->
      <div class="col-xl-6 form-group">
        <label class="form-label" for="vat_registered">UK VAT Registered</label>
        <p id="vat_registered" v-html="return_vat_registered"></p>
      </div>
      <!-- VAT Number -->
      <div class="col-xl-6 form-group" v-if="company.rel_profile.vat_registered">
        <label class="form-label" for="vat_registration_number">VAT Number</label>
        <p id="vat_registration_number" v-html="return_vat_number"></p>
      </div>
      <div class="col-12 text-right" v-if="ifNotCompanyContactUser">
        <button @click="edit_form" class="btn orcaBtn blueBtn sm_btn mb-2">Edit Company Information</button>
      </div>
    </div>
    <div v-else-if="e_company" class="row">
      <ValidationObserver ref="editCompanyInfoForm" slim tag="div" class="col-12">
        <form role="form" @submit.prevent="submit_form">
          <div class="row">
            <!-- VAT Registered -->
            <div class="col-12">
              <div class="row">
                <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="edit_payroll_recruitment_client">Company is V3 Client?</label>
                <div class="col-xl-4 form-group">
                  <bootstrap-toggle v-model="edit_company.payroll_recruitment_client" id="edit_payroll_recruitment_client" name="edit_payroll_recruitment_client"
                                    :options="{ on: 'Yes', off: 'No' }"/>
                </div>
              </div>
            </div>
            <div class="col-12">
              <hr>
            </div>
            <!-- Company Sage Ref -->
            <ValidationProvider rules="" v-slot="{errors, classes}" name="Sage Reference" tag="div" class="col-xl-6 form-group">
              <label class="form-label" for="edit_sage_ref">Sage Reference</label>
              <input type="text" v-model="edit_company.internal_finance_ref" id="edit_sage_ref" name="edit_sage_ref" class="form-input" :class="classes"
                     @input="forceUppercase($event, edit_company, 'sage_ref')">
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- Genius Trading Company -->
            <ValidationProvider rules="" v-slot="{errors, classes}" name="Genius Trading Company" tag="div" class="col-xl-6 form-group" v-if="isPayrollCrm">
              <label class="form-label" for="edit_genius_trading_company">Payroll Trading Company</label>
              <multiselect v-model="edit_payment_process_info.payroll_trading_company" id="edit_genius_trading_company" name="edit_genius_trading_company" placeholder=""
                           :options="ms_opts.genius_trading_company" :class="classes" label="value" track-by="id"></multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- Company UTR Number -->
            <ValidationProvider rules="digits:10" v-slot="{errors, classes}" name="UTR Number" tag="div" class="col-xl-6 form-group">
              <label class="form-label" for="edit_utr_number">Company UTR Number</label>
              <input type="text" v-model="edit_company_profile.utr_number" id="edit_utr_number" name="edit_utr_number" class="form-input" :class="classes" maxlength="10">
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- UTR Status -->
            <ValidationProvider rules="" v-slot="{errors, classes}" name="UTR Status" tag="div" class="col-xl-6 form-group">
              <label class="form-label" for="edit_utr_status">UTR Status</label>
              <multiselect v-model="edit_company_profile.utr_status" id="edit_utr_status" name="edit_utr_status" placeholder="" :options="ms_opts.utr_status"
                           :class="classes" label="value"></multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- VAT Registered -->
            <div class="col-xl-6 form-group">
              <div class="row">
                <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="edit_vat_registered">UK VAT Registered</label>
                <div class="col-xl-4 form-group">
                  <bootstrap-toggle v-model="edit_company_profile.vat_registered" id="edit_vat_registered" name="edit_vat_registered" :options="{ on: 'Yes', off: 'No' }"/>
                </div>
              </div>
            </div>
            <!-- VAT Registration Number -->
            <ValidationProvider rules="VATregNoValidate|max:9" v-slot="{errors, classes}" name="VAT Number" tag="div" class="col-xl-6 form-group"
                                v-if="edit_company_profile.vat_registered">
              <label class="form-label" for="edit_vat_number">VAT Number</label>
              <div class="input-group">
                <div class="input-group-prepend"><span class="input-group-text">GB</span></div>
                <input type="text" v-model="edit_company_profile.vat_number" id="edit_vat_number" name="edit_vat_number" class="form-input" :class="classes" maxlength="9">
              </div>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <!-- CANCEL AND SUBMIT BUTTONS FOR ACTIONS -->
          <div class="row mb-3">
            <div class="col-xl-6">
              <button @click.prevent="cancel_form" class="btn orcaBtn grey_bg sm_btn w-100">Cancel</button>
            </div>
            <div class="col-xl-6">
              <button type="submit" class="btn orcaBtn sm_btn w-100">Update information</button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </b-card>
</template>

<script>
import Multiselect from "vue-multiselect";
import BootstrapToggle from 'vue-bootstrap-toggle';

import { getChangedFields } from 'utils/utils';

export default {
  name: "company_information",
  components: {
    Multiselect,
    BootstrapToggle
  },
  props: [
      'ifNotCompanyContactUser',
      'company',
      'isPayrollCrm',
      'payment_process_info'
  ],
  data() {
    return {
      ms_opts: {
        genius_trading_company: this.$store.state.crm_options.payroll_trading_company,
        utr_status: this.$store.state.crm_options.utr_status,
      },
      e_company: false,
      edit_company: {},
      original_company: {},
      edit_company_profile: {},
      original_company_profile: {},
      edit_payment_process_info: {},
      original_payment_process_info: {},
    }
  },
  computed: {
    /**
     * Return the internal finance reference for the company
     * @returns {*|string}
     */
    return_internal_finance_ref() {
      return this.company.internal_finance_ref !== null ? this.company.internal_finance_ref : "&nbsp;";
    },
    /**
     * Return the payroll trading company selected for the company
     * @returns {*|string}
     */
    return_payroll_trading_company() {
      return this.payment_process_info.payroll_trading_company_id !== null
          ? this.$store.state.crm_options.payroll_trading_company.find(tc => tc.id === this.payment_process_info.payroll_trading_company_id).value
          : "&nbsp;";
    },
    /**
     * Return the utr number for the company
     * @returns {*|string}
     */
    return_utr_number() {
      return this.company.rel_profile.utr_number !== null ? this.company.rel_profile.utr_number : "&nbsp;";
    },
    /**
     * Return the utr status for the company
     * @returns {*|string}
     */
    return_utr_status() {
      return this.company.rel_profile.utr_status !== null ? this.company.rel_profile.utr_status : "&nbsp;";
    },
    /**
     * Return where the company is vat registered
     * @returns {string}
     */
    return_vat_registered() {
      return this.company.rel_profile.vat_registered ? 'Yes'
          : !this.company.rel_profile.vat_registered ? 'No'
              : "&nbsp;";
    },
    /**
     * Return the vat_number for the company
     * @returns {*|string}
     */
    return_vat_number() {
      return this.company.rel_profile.vat_number !== null ? this.company.rel_profile.vat_number : "&nbsp;";
    },
  },
  methods: {
    /**
     * Function to switch to the form to edit the values for company information for the company record
     */
    edit_form() {
      this.edit_company = Object.assign({}, this.company);
      this.original_company = Object.assign({}, this.company);
      this.edit_company_profile = Object.assign({}, this.company.rel_profile);
      this.original_company_profile = Object.assign({}, this.company.rel_profile);
      this.edit_company_profile.utr_status = this.$store.state.crm_options.utr_status.find(tc => tc.value === this.company.rel_profile.utr_status);
      this.edit_payment_process_info = Object.assign({}, this.payment_process_info);
      this.original_payment_process_info = Object.assign({}, this.payment_process_info);
      this.edit_payment_process_info['payroll_trading_company'] =
          this.$store.state.crm_options.payroll_trading_company.find(tc => tc.id === this.payment_process_info.payroll_trading_company_id);
      this.original_payment_process_info['payroll_trading_company'] = this.edit_payment_process_info['payroll_trading_company'];

      this.$nextTick(() => this.e_company = true)
    },
    /**
     * Function to close the editing form on the template
     * and reset edit data variables to initial values
     */
    cancel_form() {
        this.edit_company = {};
        this.edit_company_profile = {};
        this.edit_payment_process_info = {};
        this.e_company = false
    },
    /**
     * Form submission to save the company information inputted on the edit form
     */
    submit_form() {
      this.$refs.editCompanyInfoForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.editCompanyInfoForm);
        }
        else {
          this.$store.commit('SET_UPDATE_COMPANY_ID', this.edit_company.id);

          let company_info_promises = [];
          
          // Use the new function to get changed fields
          let changed_fields = [
            ...getChangedFields(this.original_company, this.edit_company),
            ...getChangedFields(this.original_company_profile, this.edit_company_profile),
            ...getChangedFields(this.original_payment_process_info, this.edit_payment_process_info)
          ];
          
          // Save all values that are on the company database record
          company_info_promises.push(new Promise(resolve => {
            let submit_c = {
              company_id: this.company.id,
              payroll_recruitment_client: this.edit_company.payroll_recruitment_client,
              internal_finance_ref: this.edit_company.internal_finance_ref,
              log_by_type: 'App\\Models\\Users\\User',
              log_by_id: this.$store.state.auth.me.id
            }
            axios.patch(this.crmApiPath + 'company/' + this.edit_company.id, submit_c).then(() => resolve());
          }));
          // save all values that are on the company_profile database record
          company_info_promises.push(new Promise(resolve => {
            let submit_cp = {
              company_id: this.company.id,
              utr_number: this.edit_company_profile.utr_number,
              utr_status: null,
              vat_registered: this.edit_company_profile.vat_registered,
              vat_number: this.edit_company_profile.vat_number,
              log_by_type: 'App\\Models\\Users\\User',
              log_by_id: this.$store.state.auth.me.id
            }
            // if a UTR status has been selected then set the string value for saving to the database
            if (this.edit_company_profile.utr_status !== null && this.edit_company_profile.utr_status !== undefined) {
              submit_cp.utr_status = this.edit_company_profile.utr_status.value
            }
            axios.patch(this.crmApiPath + 'company/profile/' + this.edit_company_profile.id, submit_cp).then(() => resolve());
          }));
          // save all values that are on the company_payment_process_infos database record
          company_info_promises.push(new Promise(resolve => {
            let submit_ppi = {
              company_id: this.company.id,
              payroll_trading_company_id: null,
              log_by_type: 'App\\Models\\Users\\User',
              log_by_id: this.$store.state.auth.me.id
            }
            // if a payroll trading company has been selected then set the string value for saving to the database
            if (this.edit_payment_process_info.payroll_trading_company !== null && this.edit_payment_process_info.payroll_trading_company !== undefined) {
              submit_ppi.payroll_trading_company_id = this.edit_payment_process_info.payroll_trading_company.id;
            }
            axios.patch(this.crmApiPath + 'company/payment_process_info/' + this.edit_payment_process_info.id, submit_ppi).then(() => resolve());
          }));

          if (changed_fields.length > 0) {
            // Send changed fields through AJAX on email
            company_info_promises.push(new Promise(resolve => {
              axios.post(this.crmApiPath + 'company/send_changed_email', {
                title: 'COMPANY INFORMATION',
                company_id: this.company.id,
                changes: changed_fields,
              }).then(() => resolve());
            }));
          }

          // after all the axios updates have been made the refresh the vue with the new values
          Promise.all(company_info_promises).then(() => {
            this.$bus.$emit('company_pre_agreement::reload', {action: true});
            this.$bus.$emit('company::reload', {action: true});
            this.$bus.$emit('company_payment_process::reload', {action: true});
            this.$bus.$emit('logs::reload', {action: true});
            // close form
            this.$nextTick(() => {
              this.e_company = false;
              this.$bus.$emit('table::reload', {table: 'all_companies', type: 'update'});
            })
          });
        }
      });
    },
  },
  watch: {
    // Company Information
    'edit_company_profile.vat_registered'(val) {
      if (!val) {
        this.edit_company_profile.vat_number = '';
      }
    },
  }
}
</script>
